import { render, staticRenderFns } from "./ResourceAdditionalInfo.vue?vue&type=template&id=50175e0b"
import script from "./ResourceAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./ResourceAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports